export const PUBLIC_ROUTE = {
	LANDING: '/',
	SIGN_IN: '/signin',
	FORGET_PASSWORD: '/forgotpassword',
	RESET_PASSWORD: '/resetpassword',
	PAGE_404: '/404',
	PAGE_500: '/500',
};
